import axios, { type AxiosInstance } from "axios";
import { API_ENDPOINTS } from "../../../config/api";
import { attachAuthInterceptor } from "../../../shared/utils/authInterceptor";

const API_BASE = API_ENDPOINTS.GATEWAY;

/**
 * Shared Axios instance for the Gateway API.
 *
 * Preconfigured with the gateway base URL, cookie credentials and a 30s
 * timeout, and wired with the shared auth interceptor (token refresh /
 * 401 handling).
 */
export const gatewayApi: AxiosInstance = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
    withCredentials: true,
    headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
});

attachAuthInterceptor(gatewayApi, { name: "Gateway API" });
